import type { GetWalletsDirectoryParams } from '../types/walletsDirectoryTypes'

export const walletsDirectoryKeys = {
  all: ['treasury', 'walletsDirectory'] as const,

  lists: () => [...walletsDirectoryKeys.all, 'list'] as const,
  list: (filters: GetWalletsDirectoryParams) => [...walletsDirectoryKeys.lists(), filters] as const,
}
